import { __, invertObj, prop } from 'ramda';

import { MEDIA_TYPE } from '../../../types/press-media';

export const PRISMIC_TO_TYPE_MEDIA = {
  'Communiqué de presse': MEDIA_TYPE.RELEASE,
  Publication: MEDIA_TYPE.PUBLICATION,
};

export const toMediaType = prop(__, PRISMIC_TO_TYPE_MEDIA);
export const toMediaPrismic = prop(__, invertObj(PRISMIC_TO_TYPE_MEDIA));
